export const PROPERTIES_PER_PAGE = 250;

export interface IPagination {
  count: number;
  limit: number; // items per page
}
